import React, { Component } from 'react' 
import { Link } from 'react-router-dom'
import requester from '../lib/requester'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import moment from 'moment'

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(window.localStorage.getItem('is_user')),
            tracesProgramActive : 0
        }
    }

    componentDidMount = () => {
        this.getTracesProgramActive()
    }

    getTracesProgramActive = () => {
    let url = '/api/traces/v1/program/dash-program-active'

    let principal = []
    let branch = []
 
    this.state.user.principal_group.forEach((item, index) => {
        principal.push(item.principal_code)
    })
    this.state.user.branch.forEach((item, index) => {
        branch.push(item.org_id)
    })

    // this.state.user.userdetail.forEach((item, index) => {
    //     origin.push(item.origin)
    // })

    let param = {
        principal:principal,
        branch: branch,
        source: 'arman',
        origin: this.state.user.origin
    }

    this.setState({ loading: true })
    requester.postTraces(url, param, {
        success: function(response) {
            let { data } = response.data
                // console.log(data[0].count_active)
            this.setState({ loading: false,tracesProgramActive: data[0].count_active })
        }.bind(this),
        error: function(e) {
            this.setState({ loading: false })
        }.bind(this)
    })
}


    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info">
                                    <div className="inner">
                                    <h3>{this.state.tracesProgramActive}</h3>

                                        <p>Traces - Program Active</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-bag"></i>
                                    </div>
                                    <Link to="/admin/program/summary" className="small-box-footer">More info-Program Summary <i className="fas fa-arrow-circle-right"></i></Link>
                                </div>
                            </div>
                            {/* <div className="col-lg-3 col-6">
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <h3>53<sup>%</sup></h3>

                                        <p>Bounce Rate</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-stats-bars"></i>
                                    </div>
                                    <Link to="#" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></Link>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-warning">
                                    <div className="inner">
                                        <h3>44</h3>

                                        <p>User Registrations</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add"></i>
                                    </div>
                                    <Link to="#" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></Link>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-danger">
                                    <div className="inner">
                                        <h3>65</h3>

                                        <p>Unique Visitors</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-pie-graph"></i>
                                    </div>
                                    <Link to="#" className="small-box-footer">More info <i className="fas fa-arrow-circle-right"></i></Link>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Dashboard
